// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"8045ea21","832":"2d78b4e7"}[chunkId] + ".chunk.js";
};